import { ContentieuxSocial } from '../entities/contentieux-social';
import { PieceActeAttaque, PieceComplementaire, PiecePostale, PieceReclamationPrealable, PieceRequete } from '../entities/piece-jointe';
import { PartieDepot, RequeteCategory } from '../entities/requete';
import { SiteJuridiction } from '../entities/site-juridiction';
import { TypeJuridiction } from '../entities/type-juridiction';
import { UrgenceRequete } from '../entities/urgence-requete';

export class DepotRequeteState {
    id: number;
    version: number;
    dateCreation: Date;
    statut: string | undefined;

    requeteCategory: RequeteCategory;
    requerants: PartieDepot[] = [];
    currentActeur: PartieDepot;

    typeJuridiction: TypeJuridiction;
    siteJuridiction: SiteJuridiction;
    typeActeAttaque: string;

    urgenceRequete: UrgenceRequete;
    concernContentieuxSocial: boolean;
    formActivated: boolean;
    requeteCS: ContentieuxSocial;

    requete = new PieceRequete(null);
    acteAttaque = new PieceActeAttaque(null);
    reclamationPrealable = new PieceReclamationPrealable(null);
    acteAttaquesAFusioner: PieceActeAttaque[] = [];
    reclamationPrealablesAFusioner: PieceReclamationPrealable[] = [];
    piecesComplementaires: PieceComplementaire[] = [];
    piecesPostales: PiecePostale[] = [];

    // flags to show auto save time
    isStepRequerantAutoSaveSucceed = false;
    isStepJuridictionAutoSaveSucceed = false;
    isStepRequeteAutoSaveSucceed = false;
    isStepJustificatifsAutoSaveSucceed = false;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/depot-requete-state.model.ts